var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 20C3.3335 12.1433 3.3335 8.21489 5.77428 5.77413C8.21505 3.33334 12.1434 3.33334 20.0002 3.33334C27.8568 3.33334 31.7853 3.33334 34.226 5.77413C36.6668 8.21489 36.6668 12.1433 36.6668 20C36.6668 27.8567 36.6668 31.7852 34.226 34.2258C31.7853 36.6667 27.8568 36.6667 20.0002 36.6667C12.1434 36.6667 8.21505 36.6667 5.77428 34.2258C3.3335 31.7852 3.3335 27.8567 3.3335 20ZM20.0002 10.4167C20.6905 10.4167 21.2502 10.9763 21.2502 11.6667V20.3155L24.1163 17.4495C24.6045 16.9613 25.3958 16.9613 25.884 17.4495C26.3722 17.9377 26.3722 18.729 25.884 19.2172L20.884 24.2172C20.6497 24.4517 20.3317 24.5833 20.0002 24.5833C19.6687 24.5833 19.3507 24.4517 19.1163 24.2172L14.1163 19.2172C13.6281 18.729 13.6281 17.9377 14.1163 17.4495C14.6044 16.9613 15.3959 16.9613 15.884 17.4495L18.7502 20.3155V11.6667C18.7502 10.9763 19.3098 10.4167 20.0002 10.4167ZM13.3335 27.0833C12.6431 27.0833 12.0835 27.643 12.0835 28.3333C12.0835 29.0237 12.6431 29.5833 13.3335 29.5833H26.6668C27.3572 29.5833 27.9168 29.0237 27.9168 28.3333C27.9168 27.643 27.3572 27.0833 26.6668 27.0833H13.3335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloading);
export default __webpack_public_path__ + "static/media/Downloading.c0927b0cfea66c1365c6ceae65488713.svg";
export { ForwardRef as ReactComponent };